<template>
    <v-container fill-height fluid grid-list-xl class="pt-3">
        <v-layout wrap>
            <v-flex xs12 class="px-0 pt-0">
                <v-card class="mb-4 pb-4 mt-2">
                    <v-layout column>
                        <v-card-actions class="mb-2 mt-3">
                            <v-layout
                                row
                                wrap
                                v-bind:class="{
                                    'pl-0': isMobile(),
                                    'pl-3': !isMobile(),
                                }"
                            >
                                <v-flex
                                    md5
                                    xs12
                                    class="pl-2"
                                    v-bind="{ 'py-0': isMobile() }"
                                >
                                    <div class="headline px-0 pb-2">
                                        HS Registration
                                    </div>
                                    <v-layout row class="pl-0">
                                        <v-card-text class="font-weight-regular"
                                            >Search By Phone Number</v-card-text
                                        >
                                    </v-layout>
                                    <v-layout row class="pl-3 mr-0">
                                        <v-text-field
                                            outline
                                            class="mr-2"
                                            autocomplete="new-password"
                                            mask="###-###-####"
                                            label="Phone Number"
                                            v-model="phoneSearch"
                                            :hide-details="isMobile()"
                                        ></v-text-field>
                                        <!-- <v-btn
                                            color="default"
                                            dark
                                            style="height: 48px;"
                                            class="ml-3"
                                            @click="searchDialog = true"
                                            >Search Accounts</v-btn
                                        > -->
                                    </v-layout>
                                    <v-layout row class="pl-0">
                                        <v-card-text
                                            class="font-weight-regular pt-0"
                                            >Search By Name</v-card-text
                                        >
                                        <!-- <v-btn-toggle
                                            mandatory
                                            v-model="searchNameMode"
                                            class="toggle-button-group mt-2"
                                        >
                                            <v-btn
                                                flat
                                                value="yiddish"
                                                class="toggle-button search-yiddish-button"
                                            >
                                                אידיש
                                            </v-btn>
                                            <v-btn
                                                flat
                                                value="english"
                                                class="toggle-button search-english-button"
                                            >
                                                English
                                            </v-btn>
                                        </v-btn-toggle> -->
                                    </v-layout>

                                    <v-layout row class="pl-3 mr-2">
                                        <v-text-field
                                            outline
                                            class="mr-2"
                                            autocomplete="new-password"
                                            label="לעצטע נאמען"
                                            v-model="lastNameSearchH"
                                            :hide-details="isMobile()"
                                        ></v-text-field>
                                        <v-text-field
                                            outline
                                            autocomplete="new-password"
                                            label="ערשטע נאמען"
                                            v-model="firstNameSearchH"
                                            :hide-details="isMobile()"
                                        ></v-text-field>
                                    </v-layout>
                                    <v-layout row class="pl-3 mr-2">
                                        <v-text-field
                                            outline
                                            class="mr-2"
                                            autocomplete="new-password"
                                            label="Last Name"
                                            v-model="lastNameSearch"
                                            :hide-details="isMobile()"
                                        ></v-text-field>
                                        <v-text-field
                                            outline
                                            autocomplete="new-password"
                                            label="First Name"
                                            v-model="firstNameSearch"
                                            :hide-details="isMobile()"
                                        ></v-text-field>
                                    </v-layout>
                                    <v-layout row class="mr-2">
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="success"
                                            outline
                                            style="height: 48px;"
                                            class="mt-1 ml-3"
                                            @click="enterManually"
                                            >Enter Manually</v-btn
                                        >
                                        <v-btn
                                            color="success"
                                            style="height: 48px;"
                                            class="mt-1 ml-3"
                                            @click="searchByName"
                                            >Search</v-btn
                                        >
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                        <v-layout
                            class="mx-4 my-2 headline font-weight-medium"
                            row
                            v-if="
                                accountsToDisplay &&
                                    accountsToDisplay.length &&
                                    !isMobile()
                            "
                        >
                            <div style="width: 15%">Last Name</div>
                            <div style="width: 15%">First Name</div>
                            <div style="width: 20%">
                                Father
                            </div>
                            <div style="width: 20%">
                                Father In Law
                            </div>
                            <div style="width: 20%">Address</div>
                        </v-layout>
                        <v-layout
                            class="mx-4 my-2"
                            style="border: #999 2px solid; padding: 10px; cursor: pointer;"
                            row
                            @click="selectAccount(account)"
                            v-if="
                                accountsToDisplay &&
                                    accountsToDisplay.length &&
                                    !isMobile()
                            "
                            v-for="(account, index) in accountsToDisplay"
                        >
                            <div style="width: 15%">
                                {{
                                    searchNameMode == "yiddish"
                                        ? account.lastHebrew
                                        : account.lastEnglish
                                }}
                            </div>
                            <div style="width: 15%">
                                {{
                                    searchNameMode == "yiddish"
                                        ? account.firstHebrew
                                        : account.firstEnglish
                                }}
                            </div>
                            <div style="width: 20%">
                                {{ account.father }}
                            </div>
                            <div style="width: 20%">
                                {{ account.fatherInLaw }}
                            </div>
                            <div style="width: 20%">{{ account.address1 }}</div>
                        </v-layout>
                        <v-layout
                            class="mx-4 my-2"
                            style="border: #999 2px solid; padding: 10px; cursor: pointer;"
                            column
                            @click="selectAccount(account)"
                            v-if="
                                accountsToDisplay &&
                                    accountsToDisplay.length &&
                                    isMobile()
                            "
                            v-for="(account, index) in accountsToDisplay"
                        >
                            <div class="font-weight-medium">
                                {{
                                    account.lastName + ", " + account.firstName
                                }}
                            </div>
                            <div>
                                {{ account.homePhone }}
                            </div>
                            <div>
                                {{ account.cellPhone }}
                            </div>
                            <div>{{ account.address1 }}</div>
                        </v-layout>
                        <div
                            class="mt-2 mb-3 font-weight-regular text-xs-center text-warning headline"
                            v-if="
                                showNoAccountsMessage &&
                                    (!accounts || !accounts.length) &&
                                    !account.personID
                            "
                        >
                            No Accounts Found
                        </div>
                        <v-layout
                            justify-center
                            class="mt-3 mb-1"
                            v-if="accountsToDisplay && accountsToDisplay.length"
                        >
                            <v-pagination
                                v-model="pagination.page"
                                :length="pages"
                                :total-visible="5"
                                v-on:input="setPagianation"
                            ></v-pagination>
                        </v-layout>
                    </v-layout>
                </v-card>
                <v-card class="mb-4 pb-4 pt-4" v-if="showApplication">
                    <!-- <v-btn
                        color="success"
                        class="mt-3"
                        style="margin-left: 36px;"
                        outline
                        @click="showApplication = false"
                        ><v-icon left dark>mdi-arrow-left</v-icon>Back</v-btn
                    > -->
                    <v-layout row justify-space-between>
                        <v-form ref="application">
                            <div class="mb-3 pl-3">
                                <v-flex xs12 class="pt-0">
                                    <v-layout row>
                                        <v-layout
                                            column
                                            v-bind:class="{
                                                'ml-2': isMobile(),
                                                'ml-4': !isMobile(),
                                            }"
                                        >
                                            <div
                                                v-if="
                                                    !account.personID &&
                                                        !account.parentId
                                                "
                                                class="mt-3"
                                            >
                                                <v-layout
                                                    row
                                                    class="ml-2 pl-1 mt-3 pb-2"
                                                >
                                                    <v-text-field
                                                        v-model="
                                                            application.firstNameH
                                                        "
                                                        label="First Hebrew"
                                                        class="mr-3"
                                                        :rules="[
                                                            rules.required,
                                                        ]"
                                                        ref="firstNameH"
                                                        style="width: 250px;"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        v-model="
                                                            application.lastNameH
                                                        "
                                                        label="Last Hebrew"
                                                        :rules="[
                                                            rules.required,
                                                        ]"
                                                        ref="lastNameH"
                                                        style="width: 250px;"
                                                    ></v-text-field>
                                                </v-layout>
                                                <v-layout
                                                    row
                                                    class="ml-2 pl-1 mt-0 pb-2"
                                                >
                                                    <v-text-field
                                                        v-model="
                                                            application.firstName
                                                        "
                                                        label="First English"
                                                        class="mr-3"
                                                        :rules="[
                                                            rules.required,
                                                        ]"
                                                        ref="firstName"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        v-model="
                                                            application.lastName
                                                        "
                                                        label="Last English"
                                                        :rules="[
                                                            rules.required,
                                                        ]"
                                                        ref="lastName"
                                                    ></v-text-field>
                                                </v-layout>
                                                <v-layout
                                                    row
                                                    class="ml-2 pl-1 mt-0 pb-2"
                                                >
                                                    <v-text-field
                                                        v-model="
                                                            application.homePhone
                                                        "
                                                        label="Home Phone"
                                                        class="mr-3"
                                                        :rules="[
                                                            rules.required,
                                                            rules.phoneNumber,
                                                        ]"
                                                        ref="homePhone"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        v-model="
                                                            application.cellPhone
                                                        "
                                                        label="Cellphone"
                                                        :rules="[
                                                            rules.phoneNumber,
                                                        ]"
                                                        ref="cellPhone"
                                                    ></v-text-field>
                                                </v-layout>
                                                <v-layout
                                                    row
                                                    class="ml-2 pl-1 mt-0 pb-2"
                                                >
                                                    <v-text-field
                                                        v-model="
                                                            application.address
                                                        "
                                                        label="Address"
                                                        class="mr-3"
                                                        :rules="[
                                                            rules.required,
                                                        ]"
                                                        ref="address"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        v-model="
                                                            application.zipcode
                                                        "
                                                        label="Zipcode"
                                                        @input="fillCityState"
                                                    ></v-text-field>
                                                </v-layout>
                                                <v-layout
                                                    row
                                                    class="ml-2 pl-1 mt-0 pb-2"
                                                >
                                                    <v-text-field
                                                        v-model="
                                                            application.city
                                                        "
                                                        label="City"
                                                        class="mr-3"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        v-model="
                                                            application.state
                                                        "
                                                        label="State"
                                                    ></v-text-field>
                                                </v-layout>
                                                <!-- <v-layout
                                                    row
                                                    class="ml-2 pl-1 mt-0 pb-2"
                                                >
                                                    <v-text-field
                                                        v-model="
                                                            application.emailAddress
                                                        "
                                                        label="Email Address"
                                                        :rules="[rules.email]"
                                                        ref="emailAddress"
                                                    ></v-text-field>
                                                </v-layout> -->

                                                <!-- <v-layout
                                                    row
                                                    class="ml-2 pl-1 mt-0 pb-0 mb-0"
                                                    v-if="
                                                        !application.father ||
                                                            application.fatherInLaw
                                                    "
                                                >
                                                    <v-text-field
                                                        v-model="
                                                            application.father
                                                        "
                                                        label="Father"
                                                        class="mr-3"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        v-model="
                                                            application.fatherInLaw
                                                        "
                                                        label="Father In Law"
                                                    ></v-text-field>
                                                </v-layout> -->
                                            </div>
                                            <v-layout
                                                row
                                                class="ml-2 pl-1 mt-3 pt-2"
                                            >
                                                <v-text-field
                                                    v-model="application.mother"
                                                    label="Mother"
                                                    class="mr-3"
                                                    :rules="[rules.required]"
                                                    ref="mother"
                                                ></v-text-field>
                                                <v-text-field
                                                    v-model="
                                                        application.childPlusFamilyID
                                                    "
                                                    label="ChildPlus Family ID"
                                                    :rules="[rules.required]"
                                                    ref="childPlusFamilyID"
                                                ></v-text-field>
                                            </v-layout>
                                            <v-card-title
                                                primary-title
                                                class="mt-0 pb-2 pt-0 pl-0"
                                            >
                                                <div
                                                    v-if="account.personID"
                                                    class="pl-2"
                                                >
                                                    <h3
                                                        style="font-weight: 500 !important;"
                                                        class="headline mb-0 mt-0"
                                                    >
                                                        Account ID:
                                                        {{ account.personID }}
                                                    </h3>
                                                </div>
                                            </v-card-title>
                                            <div
                                                class="cyan caption pa-1 px-2 ml-2 mb-3"
                                                v-if="account.parentId"
                                                style="color: #fff; width: fit-content;"
                                            >
                                                UTA Account
                                            </div>
                                            <div
                                                class="orange accent-3 caption pa-1 px-2 ml-2 mb-3"
                                                v-if="
                                                    !account.parentId &&
                                                        account.personID
                                                "
                                                style="color: #fff; width: fit-content;"
                                            >
                                                ANSL Account
                                            </div>
                                            <div
                                                v-if="
                                                    account.parentId ||
                                                        account.personID
                                                "
                                                class="ml-4 pl-0 mt-3"
                                            >
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Name:
                                                    </div>
                                                    <div>
                                                        {{ account.name }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Name Hebrew:
                                                    </div>
                                                    <div>
                                                        {{ account.nameH }}
                                                    </div>
                                                </v-layout>

                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Home Phone:
                                                    </div>
                                                    <div>
                                                        {{
                                                            application.homePhone
                                                        }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Cell Phone:
                                                    </div>
                                                    <div>
                                                        {{
                                                            application.cellPhone
                                                        }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Address:
                                                    </div>
                                                    <div>
                                                        {{
                                                            account.address1 +
                                                                " " +
                                                                account.city +
                                                                " " +
                                                                account.state +
                                                                " " +
                                                                account.zip
                                                        }}
                                                    </div>
                                                </v-layout>

                                                <v-layout
                                                    row
                                                    class="mb-2"
                                                    v-if="application.father"
                                                >
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Father:
                                                    </div>
                                                    <div>
                                                        {{ application.father }}
                                                    </div>
                                                </v-layout>
                                                <v-layout
                                                    row
                                                    class="mb-0"
                                                    v-if="
                                                        application.fatherInLaw
                                                    "
                                                >
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Father In Law:
                                                    </div>
                                                    <div>
                                                        {{
                                                            application.fatherInLaw
                                                        }}
                                                    </div>
                                                </v-layout>
                                            </div>
                                            <v-divider class="my-2"></v-divider
                                            ><v-card-title
                                                class="headline px-3 mb-2 pt-0 mb-3 pb-0"
                                            >
                                                Students
                                            </v-card-title>
                                            <v-layout column>
                                                <v-btn
                                                    v-if="!newStudents.length"
                                                    class="my-0"
                                                    color="success"
                                                    @click="addStudent"
                                                    >Add Student</v-btn
                                                >
                                            </v-layout>

                                            <div
                                                v-for="(student,
                                                index) in newStudents"
                                            >
                                                <v-form ref="studentForm">
                                                    <v-layout
                                                        row
                                                        class="mx-3 mb-2"
                                                    >
                                                        <v-btn
                                                            small
                                                            color="default"
                                                            dark
                                                            class="mr-2"
                                                            @click="
                                                                removeStudent(
                                                                    index
                                                                )
                                                            "
                                                            >Remove
                                                            Student</v-btn
                                                        >
                                                        <v-btn
                                                            small
                                                            color="success"
                                                            @click="addStudent"
                                                            >Add Student</v-btn
                                                        >
                                                    </v-layout>
                                                    <v-layout
                                                        row
                                                        justify-end
                                                        align-end
                                                        class="mx-1 mb-2"
                                                    >
                                                        <v-text-field
                                                            autocomplete="new-password"
                                                            label="אידישע נאמען"
                                                            v-model="
                                                                student.hebName
                                                            "
                                                            ref="studentHebName"
                                                            class="ml-3"
                                                            reverse
                                                        ></v-text-field>
                                                        <v-text-field
                                                            autocomplete="new-password"
                                                            label="English Name"
                                                            v-model="
                                                                student.engName
                                                            "
                                                            ref="studentEngName"
                                                            :rules="[
                                                                rules.required,
                                                            ]"
                                                            class="ml-3"
                                                        ></v-text-field>
                                                        <v-menu
                                                            v-model="
                                                                student.dobPickerMenu
                                                            "
                                                            :close-on-content-click="
                                                                false
                                                            "
                                                            offset-y
                                                            full-width
                                                        >
                                                            <template
                                                                v-slot:activator="{
                                                                    on,
                                                                }"
                                                            >
                                                                <v-text-field
                                                                    class="ml-3"
                                                                    v-model="
                                                                        student.dob
                                                                    "
                                                                    :value="
                                                                        student.dob
                                                                    "
                                                                    label="Date Of Birth"
                                                                    readonly
                                                                    ref="studentDOB"
                                                                    :rules="[
                                                                        rules.required,
                                                                    ]"
                                                                    v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                v-model="
                                                                    student.dob
                                                                "
                                                                @change="
                                                                    dateOfBirthChanged(
                                                                        student
                                                                    )
                                                                "
                                                            ></v-date-picker>
                                                        </v-menu>
                                                    </v-layout>
                                                    <v-layout
                                                        row
                                                        justify-end
                                                        align-end
                                                        class="mx-1 mb-2"
                                                    >
                                                        <v-layout
                                                            row
                                                            class="ml-3 pt-3 mt-2 pr-2"
                                                            style="max-width: fit-content;"
                                                            v-if="student.dob"
                                                        >
                                                            <div
                                                                class="font-weight-medium mr-2"
                                                            >
                                                                Allowed Start
                                                                Date:
                                                            </div>
                                                            <div>
                                                                {{
                                                                    getMinStartDate(
                                                                        student
                                                                    ) | date
                                                                }}
                                                            </div>
                                                        </v-layout>
                                                        <v-menu
                                                            v-model="
                                                                student.startDatePickerMenu
                                                            "
                                                            :close-on-content-click="
                                                                true
                                                            "
                                                            offset-y
                                                            full-width
                                                        >
                                                            <template
                                                                v-slot:activator="{
                                                                    on,
                                                                }"
                                                            >
                                                                <v-text-field
                                                                    class="ml-3"
                                                                    v-model="
                                                                        student.startDate
                                                                    "
                                                                    :value="
                                                                        student.startDate
                                                                    "
                                                                    label="Start Date"
                                                                    readonly
                                                                    ref="startDate"
                                                                    :rules="[
                                                                        rules.required,
                                                                    ]"
                                                                    v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                :min="
                                                                    student.minStartDate
                                                                "
                                                                v-model="
                                                                    student.startDate
                                                                "
                                                            ></v-date-picker>
                                                        </v-menu>

                                                        <v-select
                                                            color="success"
                                                            :items="years"
                                                            v-model="
                                                                student.year
                                                            "
                                                            class="my-0 ml-3"
                                                            reverse
                                                            style="max-width: 200px"
                                                            label="Year"
                                                        ></v-select>

                                                        <v-select
                                                            color="success"
                                                            :items="
                                                                getGrades(
                                                                    student
                                                                )
                                                            "
                                                            v-model="
                                                                student.classDescription
                                                            "
                                                            class="my-0 ml-3"
                                                            reverse
                                                            style="max-width: 200px"
                                                            label="Grade"
                                                        ></v-select>
                                                    </v-layout>
                                                </v-form>
                                                <v-divider
                                                    class="mb-3"
                                                    v-if="
                                                        index + 1 <
                                                            newStudents.length
                                                    "
                                                    :key="index"
                                                ></v-divider>
                                            </div>

                                            <!-- <v-checkbox
                                                v-model="sendEmailApplication"
                                                label="Send Application Email"
                                                color="success"
                                                class="ml-2"
                                            ></v-checkbox> -->

                                            <!-- <div class="ml-4 pl-1 mt-0 pb-3">
                                                <v-layout
                                                    row
                                                    class="mb-2"
                                                    v-for="phone in phonesNumbers"
                                                >
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        {{
                                                            getPhoneType(
                                                                phone.phoneType
                                                            )
                                                        }}:
                                                    </div>
                                                    <div>
                                                        {{ phone.phoneNum }}
                                                    </div>
                                                </v-layout>
                                            </div> -->
                                            <v-card-actions class="mr-0 mt-2">
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    color="success"
                                                    outline
                                                    class=""
                                                    @click="cancel"
                                                    >Cancel</v-btn
                                                >
                                                <v-btn
                                                    color="success"
                                                    class="ml-2"
                                                    :loading="processing"
                                                    @click="saveApplication"
                                                    >Save Application</v-btn
                                                >
                                            </v-card-actions>
                                        </v-layout>
                                    </v-layout>
                                </v-flex>
                            </div>
                        </v-form>
                        <v-spacer></v-spacer>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="searchDialog" max-width="1400">
            <v-card>
                <data-grid
                    class="accounts-search"
                    url="accounts"
                    :columns="accountsColumns"
                    :title="searchDialogTitle"
                    navigationPath="Account View"
                    navigationField="accountID"
                    v-bind:hideActions="true"
                    :onRowClicked="onSearchAccountsRowClicked"
                ></data-grid>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="existingAccountDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Are you sure</v-card-title
                >
                <div class="mb-2">
                    We found that the phone number you entered matching the UTA
                    account of:
                    <span class="font-weight-medium">{{
                        existingAccount.name
                    }}</span>
                    do you still want to proceed?
                </div>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="existingAccountDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn color="success" @click="setupAccount()">
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import vueSelect2 from "vue-select";
import { getDomain, sum, groupBy, onlyUnique } from "../../utils/helpers.js";
import odata from "odata-client";
import { loadOptions } from "../../utils/smLookup.js";
import moment from "moment";

export default {
    components: {
        "vue-select2": vueSelect2,
    },
    data: () => ({
        phoneSearch: "",
        firstNameSearch: "",
        lastNameSearch: "",
        firstNameSearchH: "",
        lastNameSearchH: "",
        accounts: [],
        accountsToDisplay: [],
        processing: false,

        account: {},

        students: [],
        newStudents: [],
        years: [],
        grades: [],
        gradeTerms: [],

        searchDialogTitle: "Accounts",
        searchDialog: false,
        showNoAccountsMessage: false,
        phonesNumbers: [],
        userBranch: "",
        searchNameMode: "yiddish",
        showApplication: false,
        sendEmailApplication: false,
        existingAccountDialog: false,
        existingAccount: {},

        pagination: {
            totalCount: 0,
            rowsPerPage: 15,
            page: 1,
        },

        application: {
            firstName: "",
            lastName: "",
            firstNameH: "",
            lastNameH: "",
            address: "",
            homePhone: "",
            cellPhone: "",
            personID: "",
            father: "",
            fatherInLaw: "",
            createdBy: "",
            emailAddress: "",
            zipcode: "",
            city: "",
            state: "",
            childPlusFamilyID: "",
            mother: "",
        },

        rules: {
            required: (value) => !!value || "Required.",
            phoneNumber: (v) => {
                return (
                    !v ||
                    ([10, 11].includes(v.replace(/-/g, "").length) &&
                        /^\d+$/.test(v.replace(/-/g, ""))) ||
                    "Invalid Phone Number"
                );
            },
            email: (value) => {
                if (!value) return true;

                const emails = value.split(";");

                const valid = emails.every((emailValue) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                    return pattern.test(emailValue);
                });

                return valid || "Invalid e-mail.";
            },
        },

        accountsColumns: [
            {
                sortable: true,
                label: "Name",
                field: "name",
                hidden: false,
                width: "200px",
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Name..",
                },
            },
            {
                sortable: false,
                label: "Account ID",
                field: "accountID",
                width: "115px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Account ID..",
                },
            },
            {
                sortable: false,
                label: "Hebrew Name",
                width: "250px",
                field: "hname",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Hebrew Name..",
                },
            },
            {
                sortable: false,
                label: "Home Phone",
                field: "homePhone",
                width: "150px",
                hidden: false,
                searchValue: (value) => {
                    return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
                },
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Home Phone..",
                },
            },
            {
                sortable: false,
                label: "Cellphone",
                field: "cellPhone",
                width: "150px",
                hidden: false,
                searchValue: (value) => {
                    return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
                },
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Cellphone..",
                },
            },
            {
                sortable: false,
                label: "Address",
                field: "address1",
                width: "200px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Address..",
                },
            },
            {
                sortable: false,
                label: "Email",
                field: "emailAddress",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Father",
                field: "father",
                hidden: true,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Shver",
                field: "shver",
                hidden: true,
                filterOptions: {
                    enabled: true,
                },
            },
        ],
    }),
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(this.accounts.length / this.pagination.rowsPerPage)
                : 0;
        },
    },
    async created() {
        const branch = this.$store.state.authentication.branch;

        this.userBranch = branch;

        this.loadGrades();
        this.loadGradeTerms();

        if (!this.newStudents.length) {
            this.addStudent();
        }
    },
    methods: {
        isMobile() {
            return this.$vuetify.breakpoint.name == "xs";
        },
        getLastNameLabel() {
            return this.searchNameMode == "yiddish"
                ? "לעצטע נאמען"
                : "Last Name";
        },
        getFirstNameLabel() {
            return this.searchNameMode == "yiddish"
                ? "ערשטע נאמען"
                : "First name";
        },
        onSearchAccounts(search, loading) {
            loading(true);

            this.searchAccounts(loading, search);
        },
        async searchAccounts(loading, searchTerm) {
            const request = odata({
                service: getDomain() + "/odata/",
                resources: "accounts",
            }).top(30);

            request._headers[
                "Authorization"
            ] = this.$store.state.authentication.token;

            if (searchTerm) {
                request.filter(`startswith(lastname, '${searchTerm}')`);
            }

            const response = await request.get();

            this.accounts = JSON.parse(response.body).value.map((account) => {
                account.displayName = this.getDisplayName(account);

                return account;
            });

            this.accountsToDisplay = this.accounts.slice(0, 15);

            loading(false);
        },
        setPagianation() {
            if (this.getSkip() >= this.accounts.length) return;

            const number =
                (this.pagination.page - 1) * this.pagination.rowsPerPage;

            this.accountsToDisplay = this.accounts.slice(
                number,
                number + this.pagination.rowsPerPage
            );
        },
        getSkip() {
            const page = this.pagination.page - 1;

            let skip = page * this.pagination.rowsPerPage;

            if (skip >= this.accounts.length) {
                skip = this.accounts.length - this.pagination.rowsPerPage;
            }

            return skip;
        },
        invalidStudent(field, index) {
            if (!this.$refs[field]) return;

            if (index === undefined) return;
            if (!this.$refs[field][index]) return;

            return !this.$refs[field][index].validate();
        },
        onSearchAccountsRowClicked(account) {
            this.searchDialog = false;

            account.displayName = this.getDisplayName(account);

            this.account = account;

            this.onAccountSelected();
        },
        getDisplayName(account) {
            return (
                account.lastEnglish +
                " " +
                account.firstEnglish +
                " (" +
                account.address1 +
                ")"
            );
        },
        getPhoneType(phoneType) {
            switch (phoneType) {
                case "PHON":
                    return "Home Phone";
                case "CEL":
                    return "Cellphone";
                case "MCEL":
                    return "Mother Cellphone";
            }
        },
        async searchByPhone(value) {
            if (value.length < 10) return;

            const account = await this.$http.get(
                `api/newFamilyApplications/getAccountByPhoneNumber?phone=${value}`
            );

            if (!account) {
                this.$notify({
                    text: "Account Does Not Exist",
                    group: "notification",
                    type: "warning",
                });

                this.clearSelection();
                this.accounts = [];

                return;
            }

            this.account = account;

            this.onAccountSelected();
        },
        enterManually() {
            this.showApplication = true;
            this.clearAccount();

            this.onAccountSelected();
        },
        clearAccount() {
            this.account = {};
            this.application.firstName = "";
            this.application.lastName = "";
            this.application.firstNameH = "";
            this.application.lastNameH = "";
            this.application.address = "";
            this.application.homePhone = "";
            this.application.cellPhone = "";
            this.application.personID = "";
            this.application.father = "";
            this.application.fatherInLaw = "";
            this.application.createdBy = "";
            this.application.emailAddress = "";
            this.application.zipcode = "";
            this.application.city = "";
            this.application.state = "";
            this.application.childPlusFamilyID = "";
            this.application.mother = "";
        },
        async searchByName(value) {
            // if (!this.firstNameSearch && !this.lastNameSearch) {
            //     this.clearSelection();
            //     this.accounts = accounts;
            //     this.accountsToDisplay = [];

            //     return;
            // }

            const phone = this.phoneSearch.length < 10 ? "" : this.phoneSearch;

            this.showNoAccountsMessage = false;

            const url = `api/newFamilyApplications/getAccountsByName?last=${
                this.lastNameSearch
            }&first=${this.firstNameSearch}&firstH=${
                this.firstNameSearchH
            }&lastH=${this.lastNameSearchH}&phone=${phone}`;

            const accounts = await this.$http.get(url);

            if (!accounts.length) {
                this.showNoAccountsMessage = true;
                this.clearSelection();
                this.accounts = accounts;
                this.accountsToDisplay = [];
                this.clearAccount();

                return;
            }

            if (accounts.length == 1) {
                this.account = accounts[0];

                this.onAccountSelected();
            } else {
                this.accounts = accounts;
                this.accountsToDisplay = accounts.slice(0, 15);
            }
        },
        async onSelected(account) {
            if (!account) {
                return this.clearSelection();
            }

            this.accounts = [];
            this.accountsToDisplay = [];

            this.onAccountSelected();
        },
        clearSelection() {
            this.phoneSearch = "";
            this.students = [];
            this.account = {};
        },
        async onAccountSelected() {
            // const existingApplication = await this.$http.get(
            //     "api/newFamilyApplications/getExistingApplication?personID=" +
            //         this.account.personID
            // );

            // if (existingApplication) {
            //     return this.$notify({
            //         text:
            //             (existingApplication.name
            //                 ? existingApplication.name
            //                 : "This person") +
            //             "  has already an application in the system.",
            //         group: "notification",
            //         type: "error",
            //     });
            // }

            const phone = this.phoneSearch.length < 10 ? "" : this.phoneSearch;

            if (!phone) {
                this.setupAccount();

                return;
            }

            // const existingAccount = await this.$http.get(
            //     "api/newFamilyApplications/GetTuitionAccountByPhoneNumber?phoneNumber=" +
            //         phone
            // );

            // if (existingAccount) {
            //     this.existingAccount = existingAccount;
            //     this.existingAccountDialog = true;
            //     return;
            // }

            this.setupAccount();
        },
        async setupAccount() {
            this.existingAccountDialog = false;
            this.students = [];
            this.accounts = [];
            this.accountsToDisplay = [];
            this.firstNameSearch = "";
            this.lastNameSearch = "";
            this.phoneSearch = "";

            //this.loadStudents();
            await this.loadAccountPhones();

            this.fillApplication();

            this.showApplication = true;
        },
        async fillCityState(zipcode) {
            if (!zipcode || zipcode.length < 5) return;

            const response = await this.$http.get(
                "api/newFamilyApplications/GetCityStateByZipcode?zipcode=" +
                    zipcode
            );

            if (!response) return;

            this.application.city = response.city;
            this.application.state = response.state;
        },
        fillApplication() {
            if (!this.account.personID) return;

            this.application.firstName = this.account.firstEnglish;
            this.application.lastName = this.account.lastEnglish;
            this.application.firstNameH = this.account.firstHebrew;
            this.application.lastNameH = this.account.lastHebrew;
            this.application.address = this.account.address1;
            this.application.personID = this.account.personID;
            this.application.father = this.account.father;
            this.application.fatherInLaw = this.account.fatherInLaw;
            this.application.emailAddress = this.account.emailAddress;
            this.application.zipcode = this.account.zip;

            const homePhone = this.phonesNumbers.find(
                (p) => p.phoneType == "PHON"
            );
            const cellPhone = this.phonesNumbers.find(
                (p) => p.phoneType == "CEL"
            );

            this.application.homePhone = homePhone ? homePhone.phoneNum : null;
            this.application.cellPhone = cellPhone ? cellPhone.phoneNum : null;

            this.fillCityState(this.account.zip);
        },
        getRegistrationStatus(student) {
            if (student.isRegistered === null) return "REGISTERED";

            return student.isRegistered ? "REGISTERED" : "NOT REGISTERED";
        },
        selectAccount(account) {
            this.account = account;
            this.accounts = [];
            this.accountsToDisplay = [];
            this.onAccountSelected();
        },
        async loadAccountPhones() {
            if (!this.account.personID) return;

            const phones = await this.$http.get(
                "api/newFamilyApplications/getAccountPhones?personID=" +
                    this.account.personID
            );

            this.phonesNumbers = phones;
        },
        async loadStudents() {
            const students = await this.$http.get(
                "api/students/getStudentStatuses?accountID=" +
                    this.account.accountID +
                    (this.userBranch ? "&branch=" + this.userBranch : "")
            );

            this.students = students;

            if (!this.students.length) {
                this.$notify({
                    text: "No enrolled students for this account.",
                    group: "notification",
                    type: "warning",
                });
            }
        },
        addStudent() {
            this.newStudents.push({
                engName: "",
                hebName: "",
                dob: "",
                class: "",
                classDescription: "",
                startDate: "",
                gander: "female",
                minStartDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                dobPickerMenu: false,
                startDatePickerMenu: false,
            });
        },
        removeStudent(index) {
            if (index == 0) return;

            this.newStudents.splice(index, 1);
        },
        async loadGrades() {
            const response = await this.$http.get(
                "api/newFamilyApplications/getGradesToApply"
            );

            this.grades = response.filter((g) => g.isHS);
        },
        async loadGradeTerms() {
            this.gradeTerms = await this.$http.get(
                "api/newFamilyApplications/GetGradeTerms"
            );
            this.years = this.gradeTerms
                .map((g) => g.yearDisplay)
                .filter(onlyUnique);
        },
        getGrades(student) {
            if (!this.grades) return;
            return this.grades
                .filter((g) =>
                    student.gander == "male"
                        ? g.grade.startsWith("B")
                        : !g.grade.startsWith("B")
                )
                .map((a) => a.description);
        },
        dateOfBirthChanged(student) {
            const startDate = moment(student.dob).add(32, "month");

            student.minStartDate = moment(startDate).format(
                "YYYY-MM-DD HH:mm:ss"
            );
            student.startDate = new Date(startDate).toISOString().substr(0, 10);
        },
        getMinStartDate(student) {
            return student.minStartDate;
        },
        cancel() {
            this.$router.push({
                name: "HsNewStudents",
            });
        },
        async saveApplication() {
            if (!this.$refs.application.validate(true)) return;

            if (
                this.newStudents.length &&
                !this.$refs.studentForm.some((s) => s.validate(true))
            )
                return;

            if (
                this.newStudents.some(
                    (s) => moment(s.startDate) < moment(s.minStartDate)
                )
            ) {
                this.$notify({
                    text: "Invalid Student Start Date",
                    group: "notification",
                    type: "error",
                });
                return;
            }

            try {
                this.processing = true;

                await this.$http.post("api/newFamilyApplications/registerHS", {
                    firstName: this.application.firstName,
                    lastName: this.application.lastName,
                    firstNameH: this.application.firstNameH,
                    lastNameH: this.application.lastNameH,
                    address: this.application.address,
                    zipcode: this.application.zipcode,
                    city: this.application.city,
                    state: this.application.state,
                    homePhone: this.application.homePhone,
                    cellPhone: this.application.cellPhone,
                    personID: this.application.personID,
                    father: this.application.father,
                    fatherInLaw: this.application.fatherInLaw,
                    childPlusFamilyID: this.application.childPlusFamilyID,
                    mother: this.application.mother,
                    createdBy: this.$store.state.authentication.user,
                    emailAddress: this.application.emailAddress,
                    sendEmailApplication: this.sendEmailApplication,
                    utaAccountID: this.account.parentId,
                    newStudents: this.newStudents.map((student) => {
                        student.dob = moment(student.dob).format("L");
                        student.startDate = moment(student.startDate).format(
                            "L"
                        );
                        student.regID = this.getRegID(student);
                        student.class = this.grades.find(
                            (g) => g.description == student.classDescription
                        ).grade;

                        return student;
                    }),
                });

                this.processing = false;

                this.$notify({
                    text: "Application Saved",
                    group: "notification",
                    type: "success",
                });

                this.$router.push({
                    name: "HsNewStudents",
                });
            } catch (e) {
                this.processing = false;
            }
        },
        getRegID(student) {
            if (!student.year) return;

            return this.gradeTerms.find((g) => g.yearDisplay == student.year)
                .regID;
        },
    },
};
</script>
<style>
.toggle-button {
    font-size: 15px;
    padding: 5px !important;
}
.toggle-button-group {
    height: 29px !important;
    border-radius: 10px;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active {
    background-color: #afecb2 !important;
    color: #4caf50 !important;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active.search-yiddish-button {
    border-radius: 10px 0px 0px 10px;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active.search-english-button {
    border-radius: 0px 10px 10px 0px;
}
</style>
